import { footerColumns } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-[22px]" />
              </span>
              <span className="font-heading text-[24px] font-black text-background-50">黑料免费</span>
            </div>
            <p className="mt-5 max-w-[420px] text-[14px] leading-relaxed text-background-100/75">
              黑料免费是一个公开开放的爆料内容入口，主打无需付费、不限量观看的浏览体验。
              编辑团队持续整理影视、综艺、演出与商务动向等热门爆料，所有内容公开呈现，点开即看。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-50/20 text-background-100/80 transition-colors hover:border-accent-400 hover:text-accent-400"
                >
                  <i className={`${icon} text-[17px]`} />
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="text-[15px] font-medium text-background-50">{column.title}</h4>
              <ul className="mt-5 flex flex-col gap-3">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="cursor-pointer text-[14px] text-background-100/70 transition-colors hover:text-accent-400"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-background-50/15 pt-7 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[13px] text-background-100/60">
            © 2026 黑料免费 爆料内容公开开放，无需付费，不限量观看
          </p>
          <p className="max-w-[560px] text-[12px] leading-relaxed text-background-100/50">
            站内爆料内容均来自公开讨论整理，仅供参考。如涉及不实信息，可通过内容更正渠道反馈。
          </p>
        </div>
      </div>
    </footer>
  );
}